import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './ui/Section';
export function FAQ() {
  const faqs = [{
    q: '¿El material es 100% digital? ¿Cómo lo recibo?',
    a: 'Sí. Es 100% digital. Tras la compra recibes acceso inmediato a todos los PDFs en tu email en menos de 5 minutos.'
  }, {
    q: '¿Necesito experiencia cocinando?',
    a: 'No. El pan de 90 segundos requiere 90 segundos y un microondas. El mugcake requiere 2 minutos. La complejidad aumenta gradualmente a lo largo de los 6 tomos.'
  }, {
    q: '¿Son solo recetas?',
    a: 'No. Además de las recetas, el sistema te enseña a entender qué función cumple cada ingrediente para poder sustituirlo tú mismo en cualquier plato, no solo en los que están en los tomos.'
  }, {
    q: '¿Puedo usarlo desde el móvil?',
    a: 'Sí. El PDF está optimizado para leerse y usarse desde cualquier dispositivo, incluido el móvil.'
  }, {
    q: '¿Necesito ingredientes difíciles de conseguir?',
    a: 'No. El 80% están en Mercadona. El resto en herbolarios o Amazon. El coste real es comparable o inferior al de la alimentación española estándar.'
  }, {
    q: '¿Necesito tener celiaquía o intolerancia al gluten?',
    a: 'No. El 70% de los participantes no tienen diagnóstico formal. Si experimentas hinchazón, fatiga post-comida o niebla mental, el sistema puede transformar tu experiencia.'
  }, {
    q: '¿Puedo seguir comiendo fuera en bares y restaurantes?',
    a: 'Sí. La gastronomía española es en su 70% compatible con el sistema. El Bono 5 incluye protocolos para bares, bodas, cenas de empresa y Navidad.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggle = (i: number) => setOpenIndex(prev => prev === i ? null : i);
  return <Section data-id="element-55" data-mp="wvt4xldykfyo">
      <h2 className="font-display text-2xl md:text-4xl font-bold text-center mb-10 text-brand-title" data-id="element-56" data-mp="iyms07fx1bhd">
        Preguntas frecuentes
      </h2>

      <div className="max-w-2xl mx-auto space-y-3" data-id="element-57" data-mp="myokpr3oauki">
        {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return <div key={i} className="bg-white border border-brand-border rounded-xl shadow-card overflow-hidden" data-id="element-58" data-mp="2popzwv0l2fbq" data-mpi={i}>
              <button onClick={() => toggle(i)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-3 text-left px-5 py-4" data-id="element-59" data-mp="2fwttmwocfiwf">
                <span className="font-heading font-bold text-brand-title text-sm md:text-base" data-id="element-60" data-mp="2az1yltsejgo0">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-primary shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-61" data-mp="33meoactv04lj" />
              </button>
              {isOpen && <p className="font-body text-brand-text text-sm leading-relaxed px-5 pb-4" data-id="element-62" data-mp="2ylian7jph42x">
                  {faq.a}
                </p>}
            </div>;
      })}
      </div>
    </Section>;
}